import React from "react";
import Notification from "./Notification";

const Index = () => {
    return <Notification />
}

export default Index;